import { Link } from 'react-router-dom'
import { ShieldCheck, LogOut } from 'lucide-react'
import { useAuth } from '../auth/AuthContext'

/**
 * Bandeau affiché uniquement lorsqu'un administrateur est connecté.
 * Sur le site public, la connexion n'est jamais imposée : ce bandeau
 * matérialise simplement le « mode édition » à venir.
 */
export function AdminBar() {
  const { user, logout } = useAuth()
  if (!user) return null

  return (
    <div className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-3 bg-ink px-4 py-1.5 text-xs text-white/90">
      <ShieldCheck className="h-3.5 w-3.5 text-orange" />
      <span>
        Mode administrateur — connecté en tant que <strong className="text-white">{user.display_name}</strong>
      </span>
      <Link to="/admin" className="rounded-full bg-white/10 px-2.5 py-0.5 hover:bg-white/20">
        Tableau de bord
      </Link>
      <button onClick={logout} className="flex items-center gap-1 hover:text-white">
        <LogOut className="h-3.5 w-3.5" /> Déconnexion
      </button>
    </div>
  )
}
